<template>
    <div class="empty-content">
        <div><i class="el-icon-warning-outline"></i></div>
        <div class="text">{{msg||"暂无数据"}}</div>
    </div>
</template>

<script>
    export default {
        name: "EmptyContent",
        props:['msg']
    }
</script>

<style scoped lang="scss">
    .empty-content{
        border-radius: 4px;
        border:solid 1px #eee;
        text-align: center;
        padding:50px 0px;
        color:#C0C4CC;

        i{
            font-size:100px;
        }

        .text{
            font-size: 35px;
            margin-top:20px;
        }
    }
</style>